// extracted by mini-css-extract-plugin
export default {"container":"Me_container__RM6og","label":"Me_label__j-te+","data":"Me_data__zrUPw","fio":"Me_fio__qUzi5","phone":"Me_phone__svjpv"};